<template>
  <div class="animated fadeIn">
    <template v-if="collection.length">
      <potato-form
        v-for="(submission, index) in collection"
        :key="index"
        :submission="submission"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :turnArounds="
          sampleType && sampleType.getTurnarounds()
            ? sampleType.getTurnarounds()
            : null
        "
        :serviceQuestions="
          sampleType && sampleType.getServiceQuestions()
            ? sampleType.getServiceQuestions()
            : null
        "
        :index="index"
        @onSubmissionChange="onSubmissionChange"
        @removeSubmission="removeSubmission"
      ></potato-form>
    </template>
    <b-button variant="success" block @click="newSubmission"
      ><i class="fal fa-plus"></i
    ></b-button>
  </div>
</template>

<script>
import PotatoForm from "./form/PotatoForm";
import Submission from "../../../models/legacy/Submission";
import TestPackageSampleCollection from "../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../collections/lab/TestPackageCollection";
export default {
  name: "PotatoSubmissionForm",
  components: { PotatoForm },
  props: {
    submissions: {
      type: Array,
      default: () => []
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    testPackage: {
      type: Object,
      default: () => null
    },
    sampleType: {
      type: Object,
      default: () => null
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    }
  },
  data() {
    return {
      collection: []
    };
  },
  methods: {
    newSubmission() {
      this.collection = [...this.collection, this.fillSubmission({})];
    },
    fillSubmission(data) {
      data = data || {};
      data = JSON.parse(JSON.stringify(data));
      data.sample_type = this.sampleType
        ? JSON.parse(JSON.stringify(this.sampleType))
        : null;
      data.test_package = this.testPackage
        ? JSON.parse(JSON.stringify(this.testPackage))
        : null;
      data.submission_potato = data.submission_potato || {};
      if (!data.samples || !data.samples.length) {
        data.samples = [];
        this.testPackageSamples.models.forEach(sample => {
          data.samples = [
            ...data.samples,
            {
              test_package_sample_id: sample.id || this.$uuid.v4(),
              identifier: sample.name,
              sample_potato: sample.sample_potato || {
                field: null,
                harvest_date: null
              }
            }
          ];
        });
      }
      if (data.samples && data.samples.length) {
        data.samples.forEach((sample, index) => {
          this.testPackageSamples.models.forEach(testPackageSample => {
            if (testPackageSample.id === sample.test_package_sample_id) {
              sample.test_package_samples = [];
              let temp = JSON.parse(JSON.stringify(testPackageSample));
              sample.test_package_samples = [
                ...sample.test_package_samples,
                temp
              ];
              if (!sample.identifier) {
                sample.identifier = testPackageSample.name;
              }
            }
          });
          data.samples[index] = sample;
        });
      }

      if (this.$cookies.get("faker_enabled") === "1") {
        data.identifier = data.identifier || this.$faker().name.lastName();
        data.event_code =
          data.event_code ||
          data.identifier.replace(/\W/g, "").toUpperCase() +
            "-" +
            new Date().getUTCMilliseconds();
        data.submission_potato.projections = data.submission_potato
          .projections || {
          grower: null,
          storage_bin: null
        };
      }
      return new Submission(data);
    },
    onSubmissionsChange() {
      this.$emit("onSubmissionsChange", this.collection);
    },
    onSubmissionChange(params) {
      if (params && params.submission && params.index !== null) {
        this.collection.splice(
          params.index,
          1,
          this.fillSubmission(params.submission)
        );
        this.onSubmissionsChange();
      }
    },
    removeSubmission(index) {
      if (index !== null) {
        this.collection.splice(index, 1);
      }
    }
  },
  mounted() {
    if (!this.submissions.length) {
      this.newSubmission();
    } else {
      this.submissions.forEach(submission => {
        this.collection = [...this.collection, this.fillSubmission(submission)];
      });
    }
  }
};
</script>
